import axios from "axios";

const normalizeBase = (b) => String(b || "").trim().replace(/\/+$/, "");
const API_BASE = normalizeBase(import.meta.env.VITE_API_BASE_URL || "");

async function request(method, path, { params, data, signal } = {}) {
  const response = await axios({
    method,
    url: `${API_BASE}${path}`,
    params: params ? { ...params, _ts: Date.now() } : undefined,
    data,
    timeout: 45000,
    validateStatus: (status) => status >= 200 && status < 500,
    signal,
  });

  if (response.status >= 400 || response?.data?.ok === false) {
    throw new Error(response?.data?.message || response?.data?.error || `Erro HTTP ${response.status}`);
  }

  return response.data?.data ?? response.data;
}

export async function fetchRotasPlanejadasDashboard(params = {}, options = {}) {
  return request("get", "/api/mercos/rotas-planejadas/dashboard", { params, signal: options.signal });
}

export async function fetchRotasPlanejadasRecords(params = {}, options = {}) {
  return request("get", "/api/mercos/rotas-planejadas/records", { params, signal: options.signal });
}

export async function fetchRotaPlanejadaById(id, options = {}) {
  return request("get", `/api/mercos/rotas-planejadas/records/${id}`, { signal: options.signal });
}

export async function fetchRotaPlanejadaHistory(id, options = {}) {
  return request("get", `/api/mercos/rotas-planejadas/records/${id}/history`, { signal: options.signal });
}

export async function createRotaPlanejada(payload) {
  return request("post", "/api/mercos/rotas-planejadas/records", { data: payload });
}

export async function updateRotaPlanejada(id, payload) {
  return request("put", `/api/mercos/rotas-planejadas/records/${id}`, { data: payload });
}

export async function deleteRotaPlanejada(id) {
  return request("delete", `/api/mercos/rotas-planejadas/records/${id}`);
}

export async function deleteRotaPlanejadaHistory(id, options = {}) {
  if (options.byHistoryId) {
    return request("delete", `/api/mercos/rotas-planejadas/history/${id}`);
  }

  return request("delete", `/api/mercos/rotas-planejadas/records/${id}/history`);
}
